import { useState } from "react";
import { getNavItems } from "../utils/navItems";

export default function Sidebar({ currentPage, onNavigate, user, onLogout, t, isDark, toggleTheme }) {
    const navItems = getNavItems(user.accountType);
    const [branchExpanded, setBranchExpanded] = useState(false);

    return (
        <aside style={{ width: 220, background: t.surface, display: "flex", flexDirection: "column", padding: "0 0 16px", borderRight: `1px solid ${t.border}`, flexShrink: 0 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "20px 20px 16px", borderBottom: `1px solid ${t.border}` }}>
                <span style={{ fontSize: 24 }}>👁️</span>
                <span style={{ fontSize: 20, fontWeight: 700 }}>
                    <span style={{ color: t.text }}>A-</span><span style={{ color: t.accent }}>EYE</span>
                </span>
            </div>

            <div onClick={() => setBranchExpanded(!branchExpanded)}
                style={{ margin: "12px 10px 4px", padding: "10px 12px", background: user.merchant ? `${user.merchant.color}18` : t.accentBg, border: `1px solid ${user.merchant ? user.merchant.color + "55" : t.border}`, borderRadius: 10, cursor: "pointer" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <span style={{ fontSize: 20, minWidth: 26, textAlign: "center" }}>{user.merchant?.icon || "👤"}</span>
                    <div style={{ flex: 1, overflow: "hidden" }}>
                        <p style={{ color: t.text, fontSize: 12, margin: 0, fontWeight: 700, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{user.branch?.name || user.email}</p>
                        <p style={{ color: t.textMuted, fontSize: 11, margin: "1px 0 0", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{user.merchant?.name || ""}</p>
                    </div>
                    <span style={{ color: t.textFaint, fontSize: 12, flexShrink: 0 }}>{branchExpanded ? "▲" : "▼"}</span>
                </div>
                {user.region && (
                    <div style={{ marginTop: 7 }}>
                        <span style={{ fontSize: 10, padding: "2px 8px", borderRadius: 20, fontWeight: 600, background: user.merchant ? `${user.merchant.color}30` : t.inputBg, color: user.merchant?.color || t.accentText, border: `1px solid ${user.merchant ? user.merchant.color + "44" : t.border}` }}>
                            📍 {user.region}
                        </span>
                    </div>
                )}
                {branchExpanded && (
                    <div style={{ marginTop: 10, paddingTop: 10, borderTop: `1px solid ${user.merchant ? user.merchant.color + "33" : t.border}`, display: "flex", flexDirection: "column", gap: 5 }}>
                        {[
                            { icon: "🏪", label: user.merchant?.name || "—" },
                            { icon: "📍", label: user.region || "—" },
                            { icon: "🏬", label: user.branch?.name || "—" },
                            { icon: "📮", label: user.branch?.address || "—" },
                            { icon: "📧", label: user.email, mono: true },
                        ].map((row, i) => (
                            <div key={i} style={{ display: "flex", gap: 6, alignItems: "flex-start" }}>
                                <span style={{ fontSize: 11, minWidth: 16 }}>{row.icon}</span>
                                <span style={{ color: t.textMuted, fontSize: 10, fontFamily: row.mono ? "monospace" : "inherit", wordBreak: "break-all", lineHeight: 1.4 }}>{row.label}</span>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            <nav style={{ flex: 1, padding: "8px 8px 0" }}>
                {navItems.map((item) => {
                    const isActive = currentPage === item.id;
                    return (
                        <button key={item.id} onClick={() => onNavigate(item.id)}
                            style={{ display: "flex", alignItems: "center", gap: 10, width: "100%", padding: "10px 12px", marginBottom: 2, borderRadius: 8, border: "none", background: isActive ? t.navActive : "transparent", color: isActive ? t.accentText : t.textMuted, cursor: "pointer", fontSize: 14, textAlign: "left", fontWeight: isActive ? 600 : 400, transition: "all 0.15s" }}
                            onMouseEnter={(e) => { if (!isActive) e.currentTarget.style.background = t.inputBg; }}
                            onMouseLeave={(e) => { if (!isActive) e.currentTarget.style.background = "transparent"; }}>
                            <span style={{ fontSize: 17 }}>{item.icon}</span>
                            <span>{item.label}</span>
                            {isActive && <span style={{ marginLeft: "auto", width: 4, height: 4, borderRadius: "50%", background: t.accentText, flexShrink: 0 }} />}
                        </button>
                    );
                })}
            </nav>

            <div style={{ padding: "12px 10px 0", borderTop: `1px solid ${t.border}`, marginTop: 8 }}>
                <button onClick={toggleTheme} style={{ width: "100%", padding: "8px 12px", marginBottom: 8, background: t.inputBg, border: `1px solid ${t.border}`, color: t.textMuted, borderRadius: 8, cursor: "pointer", fontSize: 12, display: "flex", alignItems: "center", gap: 8 }}>
                    <span>{isDark ? "☀️" : "🌙"}</span>
                    <span>{isDark ? "切換淺色主題" : "切換深色主題"}</span>
                </button>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "4px 10px", borderRadius: 20, marginBottom: 8, background: user.accountType === "developer" ? "#1e1b4b" : t.accentBg, border: `1px solid ${user.accountType === "developer" ? "#3730a3" : t.border}` }}>
                    <span style={{ fontSize: 11, fontWeight: 600, color: user.accountType === "developer" ? "#a5b4fc" : t.accentText }}>
                        {user.accountType === "developer" ? "🛠️ Developer Account" : "🏪 Retail Account"}
                    </span>
                </div>
                <button onClick={onLogout}
                    style={{ width: "100%", padding: "8px 12px", background: "transparent", border: `1px solid ${t.border}`, color: t.textMuted, borderRadius: 8, cursor: "pointer", fontSize: 13, display: "flex", alignItems: "center", justifyContent: "center", gap: 6 }}
                    onMouseEnter={(e) => { e.currentTarget.style.borderColor = t.danger; e.currentTarget.style.color = t.danger; }}
                    onMouseLeave={(e) => { e.currentTarget.style.borderColor = t.border; e.currentTarget.style.color = t.textMuted; }}>
                    <span>⎋</span><span>登出</span>
                </button>
            </div>
        </aside>
    );
}